import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { BudgetForecast, BudgetForecastCreate, BudgetForecastFilter } from '../data/budgetForecast';

export function createBudgetForecastService(client: AxiosInstance) {
  return createCrudService<BudgetForecast, BudgetForecastCreate, BudgetForecastFilter>(
    client,
    '/accounting/BudgetForecast',
    'id',
  );
}

export type BudgetForecastService = CrudService<BudgetForecast, BudgetForecastCreate, BudgetForecastFilter>;
